import React from 'react';
import { Box, Heading, ExternalLink } from '../core';
import { ExternalLinkIcon } from '../icons';
import { IChain, getExplorerUrl, useVaultPageSubgraph } from '@sc1/common';
import { StrategyDescription } from '../Strategy/StrategyDescription';

interface VaultDescriptionProps {
  vaultName: string;
  address?: string;
  chain: IChain;
}

export const VaultDescription = ({
  vaultName,
  address,
  chain,
}: VaultDescriptionProps): JSX.Element | null => {
  const strategies = useVaultPageSubgraph()?.data?.vault?.strategies;
  const explorer = getExplorerUrl(chain);
  const url = `${explorer}address/${address}`;
  if (!strategies) return null;
  return (
    <Box mt={[6, 7]}>
      <ExternalLink
        sx={{ fontSize: 2 }}
        postfix={<ExternalLinkIcon />}
        href={url}
      >
        <Heading as="h3">Active Strategies for {vaultName}</Heading>
      </ExternalLink>

      {strategies?.length
        ? strategies.map((strategy) => (
            <StrategyDescription
              key={`${strategy.id}${chain}`}
              strategy={strategy}
              chain={chain}
            />
          ))
        : 'No active strategies'}
    </Box>
  );
};
